/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
function enforceQuantityLimit() {
  document.querySelectorAll('quantity-input').forEach(function(component) {
    if (component.dataset.limited) return;
    var input = component.querySelector('input[name="quantity"]');
    var plusBtn = component.querySelector('[plus]');
    if (!input) return;

    // Find the hidden inventory input
    var qtyData = document.querySelector('[data-qty]');
    var max = qtyData ? parseInt(qtyData.getAttribute('data-qty')) : null;
    if (!max || max <= 0) return;

    component.dataset.limited = 'true';

    plusBtn && plusBtn.addEventListener('click', function() {
      setTimeout(function() {
        if (parseInt(input.value) > max) input.value = max;
      }, 0);
    });

    input.addEventListener('change', function() {
      if (parseInt(input.value) > max) input.value = max;
    });

    input.addEventListener('input', function() {
      if (parseInt(input.value) > max) input.value = max;
    });
  });
}

document.addEventListener('DOMContentLoaded', enforceQuantityLimit);

function handlePreorderButton() {
  if (!window.productTags) return;

  var tags = window.productTags.map(function(t) { return t.toLowerCase(); });
  var today = new Date();
  today.setHours(0, 0, 0, 0);

  var releaseDateStr = null;
  var releaseDate = null;

  for (var i = 0; i < tags.length; i++) {
    var tag = tags[i];
    if (/^b\d{6}$/.test(tag)) tag = tag.slice(1);
    if (/^\d{6}$/.test(tag)) {
      var mm = tag.slice(0, 2);
      var dd = tag.slice(2, 4);
      var yy = '20' + tag.slice(4, 6);
      releaseDate = new Date(parseInt(yy), parseInt(mm) - 1, parseInt(dd));
      releaseDateStr = mm + '/' + dd + '/' + yy;
      break;
    }
  }

  if (!releaseDate || releaseDate <= today) return;

  var addBtn = document.querySelector('button[name="add"]');
  if (!addBtn) return;

  addBtn.style.backgroundColor = '#f5c518';
  addBtn.style.color = '#000';
  addBtn.style.borderColor = '#f5c518';
  var btnText = addBtn.querySelector('.js-product-add-text');
  if (btnText) btnText.textContent = 'PRE-ORDER';

  if (!document.querySelector('.preorder-release-date')) {
    var dateEl = document.createElement('p');
    dateEl.className = 'preorder-release-date';
    dateEl.style.cssText = 'color:#cc0000;font-weight:700;margin-top:8px;font-size:14px;letter-spacing:0.05em;';
    dateEl.textContent = 'RELEASE DATE: ' + releaseDateStr;
    addBtn.closest('.product-form__add').appendChild(dateEl);
  }
}

document.addEventListener('DOMContentLoaded', handlePreorderButton);